/* ============================================================
   hæld — global theme behaviour
   Scroll-reveal + hero product-view carousel.
   ============================================================ */
(function () {
  // ---- scroll-reveal ----
  // Opt in to the hidden-then-animate styles only when we can actually run and
  // observe. Anything already on screen is revealed immediately; a safety net
  // reveals everything shortly after load so content can never stay invisible.
  var pending = [].slice.call(document.querySelectorAll('.reveal, .stagger'));

  if (pending.length && 'IntersectionObserver' in window) {
    var root = document.documentElement;
    root.classList.add('js-reveal');

    function reveal(el) {
      el.classList.add('in');
      io.unobserve(el);
      var i = pending.indexOf(el);
      if (i > -1) pending.splice(i, 1);
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) reveal(e.target); });
    }, { threshold: 0.12, rootMargin: '0px 0px -5% 0px' });

    pending.slice().forEach(function (el) {
      // Anything already on screen is shown at once — nothing should animate
      // into place at a position the visitor never scrolled to.
      if (el.getBoundingClientRect().top < window.innerHeight * 1.1) reveal(el);
      else io.observe(el);
    });

    // Safety net so content can never be stranded at opacity 0.
    //
    // This used to be a blanket `reveal everything after 2.5s`, which meant that
    // for anyone who paused on the hero for three seconds — most visitors — every
    // section on the page was already revealed before they scrolled to it, and
    // none of the choreography below the fold ever ran.
    //
    // So the net is position-aware: it only rescues what is actually on screen,
    // and re-checks on scroll and resize (content can reflow under you as images
    // load). The 0.6 threshold is deliberately later than the observer's, so in
    // normal operation the observer always wins and this never fires.
    var queued = false;
    function rescue() {
      queued = false;
      pending.slice().forEach(function (el) {
        if (el.getBoundingClientRect().top < window.innerHeight * 0.6) reveal(el);
      });
      if (!pending.length) {
        window.removeEventListener('scroll', onScrollOrResize);
        window.removeEventListener('resize', onScrollOrResize);
      }
    }
    function onScrollOrResize() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(rescue);
    }

    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize);
    window.setTimeout(rescue, 2500);
  }

  // ---- mobile nav toggle ----
  document.querySelectorAll('[data-nav]').forEach(function (nav) {
    var toggle = nav.querySelector('[data-nav-toggle]');
    if (!toggle) return;

    function setOpen(open) {
      nav.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', String(open));
    }

    toggle.addEventListener('click', function () {
      setOpen(!nav.classList.contains('is-open'));
    });

    // Close when a link is tapped, on Escape, or on outside tap.
    nav.querySelectorAll('.nav-menu a').forEach(function (a) {
      a.addEventListener('click', function () { setOpen(false); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setOpen(false);
    });
    document.addEventListener('click', function (e) {
      if (!nav.contains(e.target)) setOpen(false);
    });
    // Reset when resizing back up to desktop. Must match the collapse
    // breakpoint in base.css, or the panel is left open over an inline nav.
    window.addEventListener('resize', function () {
      if (window.innerWidth > 1080) setOpen(false);
    });
  });

  // ---- hero carousel: quiet crossfade between product views ----
  document.querySelectorAll('[data-hero-carousel]').forEach(function (heroCarousel) {
    var slides = [].slice.call(heroCarousel.querySelectorAll('.hero-slide'));
    var dots = [].slice.call(heroCarousel.querySelectorAll('[data-hero-dot]'));
    if (!slides.length) return;
    var viewName = heroCarousel.querySelector('.hero-view-name');
    var viewIndex = heroCarousel.querySelector('.hero-view-index');
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var current = 0;
    var timer;

    function showView(next) {
      current = (next + slides.length) % slides.length;
      slides.forEach(function (slide, index) {
        var active = index === current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
      });
      dots.forEach(function (dot, index) {
        var active = index === current;
        dot.classList.toggle('is-active', active);
        if (active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      if (viewName) viewName.textContent = slides[current].dataset.view || '';
      if (viewIndex) {
        viewIndex.textContent =
          String(current + 1).padStart(2, '0') + ' / ' + String(slides.length).padStart(2, '0');
      }
    }

    function stopCarousel() { window.clearInterval(timer); }
    function startCarousel() {
      stopCarousel();
      if (!reduceMotion && slides.length > 1) {
        timer = window.setInterval(function () { showView(current + 1); }, 5200);
      }
    }

    var prev = heroCarousel.querySelector('[data-hero-prev]');
    var next = heroCarousel.querySelector('[data-hero-next]');
    if (prev) prev.addEventListener('click', function () { showView(current - 1); startCarousel(); });
    if (next) next.addEventListener('click', function () { showView(current + 1); startCarousel(); });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () { showView(Number(dot.dataset.heroDot)); startCarousel(); });
    });
    heroCarousel.addEventListener('mouseenter', stopCarousel);
    heroCarousel.addEventListener('mouseleave', startCarousel);
    heroCarousel.addEventListener('focusin', stopCarousel);
    heroCarousel.addEventListener('focusout', function (event) {
      if (!heroCarousel.contains(event.relatedTarget)) startCarousel();
    });
    startCarousel();
  });

  // ---- shared: header cart count ----
  // Defined here rather than in product.js because both the add-to-cart panel
  // and the cart page need it, and two copies would drift.
  window.haeld = window.haeld || {};
  window.haeld.setCartCount = function (count) {
    var badge = document.querySelector('[data-cart-count]');
    if (badge) {
      badge.textContent = count;
      badge.hidden = count === 0;
    }
    var link = document.querySelector('[data-cart-link]');
    if (link) {
      link.setAttribute('aria-label', count > 0
        ? 'Cart, ' + count + ' item' + (count === 1 ? '' : 's')
        : 'Cart');
    }
  };

  // ---- cart: quantity and remove without a page reload ----
  // The controls are real links pointing at Shopify's change URL, so with JS
  // off the cart still works exactly as before. Here we intercept and re-render
  // through the Section Rendering API: the server returns the cart section's
  // HTML with subtotal, per-line savings and the pre-order note all recomputed,
  // so none of that pricing logic has to be duplicated in JS and kept in step.
  (function () {
    // The wrapper id is NOT "shopify-section-main": Shopify prefixes sections in
    // a JSON template with the template's own id, e.g.
    // shopify-section-template--32019736527197__main. That number changes if the
    // template is ever recreated, so find the section from the content and read
    // the id back off it rather than hardcoding either half.
    var itemsRoot = document.querySelector('.cart-items');
    var host = itemsRoot && itemsRoot.closest('[id^="shopify-section-"]');
    if (!host || !window.fetch) return;
    var sectionId = host.id.replace(/^shopify-section-/, '');

    var busy = false;

    document.addEventListener('click', function (e) {
      var link = e.target.closest ? e.target.closest('[data-cart-change]') : null;
      if (!link || !host.contains(link)) return;
      e.preventDefault();
      if (busy) return;
      busy = true;
      host.classList.add('is-updating');

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          line: Number(link.dataset.line),
          quantity: Number(link.dataset.quantity),
          sections: sectionId,
          sections_url: '/cart'
        })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('cart update failed');
          return res.json();
        })
        .then(function (cart) {
          var html = cart.sections && cart.sections[sectionId];
          if (!html) throw new Error('no section returned');
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.getElementById(host.id);
          host.innerHTML = fresh ? fresh.innerHTML : doc.body.innerHTML;
          window.haeld.setCartCount(cart.item_count);
        })
        .catch(function () {
          // Fall back to the link's own href so a failed update still does the
          // right thing rather than appearing to do nothing.
          window.location.href = link.href;
        })
        .then(function () {
          busy = false;
          host.classList.remove('is-updating');
        });
    });
  })();

  // ---- bodies: rotate every figure to the same view at once ----
  // The point of the section is the comparison, so the figures never fall out
  // of sync — one control drives all of them.
  document.querySelectorAll('[data-bodies]').forEach(function (grid) {
    var section = grid.closest('.bodies') || document;
    var tabs = [].slice.call(section.querySelectorAll('[data-body-view]'));
    var imgs = [].slice.call(grid.querySelectorAll('[data-body-img]'));
    var vids = [].slice.call(grid.querySelectorAll('[data-body-video]'));
    if (!tabs.length || !imgs.length) return;

    // The 'turn' view swaps every still for its clip. Reduced motion never
    // autoplays: the button still works, but the clip waits behind its own
    // controls so the movement stays the reader's choice.
    var reduce = window.matchMedia
      && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var turning = false;

    // All three clips are the same length, so restarting them together is what
    // keeps the comparison honest — same moment of the turn on every body.
    function playAll() {
      vids.forEach(function (v) {
        v.currentTime = 0;
        var playing = v.play();
        if (playing && playing.catch) playing.catch(function () {});
      });
    }

    function setView(view) {
      turning = view === 'turn';
      tabs.forEach(function (tab) {
        tab.setAttribute('aria-pressed', String(tab.dataset.bodyView === view));
      });
      imgs.forEach(function (img) {
        var active = !turning && img.dataset.bodyImg === view;
        img.classList.toggle('is-active', active);
        if (active) img.removeAttribute('aria-hidden');
        else img.setAttribute('aria-hidden', 'true');
      });
      vids.forEach(function (v) {
        v.classList.toggle('is-active', turning);
        if (turning) v.removeAttribute('aria-hidden');
        else v.setAttribute('aria-hidden', 'true');
      });

      if (!turning) {
        vids.forEach(function (v) { v.pause(); v.currentTime = 0; });
      } else if (reduce) {
        vids.forEach(function (v) { v.controls = true; });
      } else {
        playAll();
      }
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () { setView(tab.dataset.bodyView); });
    });

    // Three clips decoding off-screen is pure battery cost on a product page.
    if (vids.length && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        if (!turning || reduce) return;
        entries.forEach(function (entry) {
          if (entry.isIntersecting) playAll();
          else vids.forEach(function (v) { v.pause(); });
        });
      }, { threshold: 0.15 }).observe(grid);
    }
  });

  // ---- product gallery video: don't autoplay under reduced motion ----
  // Shopify's video_tag emits autoplay/loop; honour the user's setting by
  // stopping it and handing them the controls instead.
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('.product-media video').forEach(function (v) {
      v.autoplay = false;
      v.controls = true;
      v.pause();
    });
  }

  // ---- country / currency picker ----
  // Each option is a real submit button inside Shopify's localization form, so
  // choosing a country works with JS disabled too (the panel is just always
  // open in that case). All this adds is the disclosure and the type-to-filter.
  var pickers = [].slice.call(document.querySelectorAll('[data-loc]'));

  pickers.forEach(function (picker) {
    var toggle = picker.querySelector('[data-loc-toggle]');
    var panel = picker.querySelector('[data-loc-panel]');
    if (!toggle || !panel) return;

    var search = picker.querySelector('[data-loc-search]');
    var empty = picker.querySelector('[data-loc-empty]');
    var items = [].slice.call(picker.querySelectorAll('[data-loc-item]'));

    function setOpen(open) {
      picker.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', String(open));
      panel.hidden = !open;

      if (open) {
        // Jump straight to the current country so it isn't buried in 200+ rows.
        var active = panel.querySelector('.loc-option.is-active');
        if (active) active.scrollIntoView({ block: 'nearest' });
        if (search) search.focus();
      }
    }

    // Close the others first — two open panels would overlap.
    toggle.addEventListener('click', function () {
      var willOpen = panel.hidden;
      closeAll();
      if (willOpen) setOpen(true);
    });

    picker.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !panel.hidden) {
        setOpen(false);
        toggle.focus();
      }
    });

    document.addEventListener('click', function (e) {
      if (!picker.contains(e.target)) setOpen(false);
    });

    if (search) {
      search.addEventListener('input', function () {
        var q = search.value.trim().toLowerCase();
        var matches = 0;

        items.forEach(function (item) {
          var hit = !q || (item.dataset.locName || '').indexOf(q) !== -1;
          item.hidden = !hit;
          if (hit) matches++;
        });

        if (empty) empty.hidden = matches !== 0;
      });

      // Enter with a single match picks it, rather than submitting nothing.
      search.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter') return;
        e.preventDefault();
        var visible = items.filter(function (item) { return !item.hidden; });
        if (visible.length === 1) visible[0].querySelector('.loc-option').click();
      });
    }

    picker._locClose = function () { setOpen(false); };
  });

  function closeAll() {
    pickers.forEach(function (p) { if (p._locClose) p._locClose(); });
  }
})();
